<template>
    <div class="task-one-time">
        <input type="hidden" name="one_time" :value="one_time_task ? '1' : '0'">
        <!--<el-switch-->
                <!--v-model="one_time_task"-->
                <!--active-color="#13ce66"-->
                <!--inactive-color="#ff4949"-->
                <!--:active-text="trans('tasks.fields.one_time_values.yes')"-->
                <!--:inactive-text="trans('tasks.fields.one_time_values.no')">-->
        <!--</el-switch>-->
        <el-radio v-model="one_time_task" :label="true" border>{{trans('tasks.fields.one_time_values.yes')}}</el-radio>
        <el-radio v-model="one_time_task" :label="false" border>{{trans('tasks.fields.one_time_values.no')}}</el-radio>
    </div>
</template>

<script>
    export default {
        name: "task-one-time-switcher",
        props: ['oneTime'],
        data() {
            return {
                one_time_task: !!this.oneTime
            }
        },
        methods: {
            trans: function (path) {
                return Lang.trans(path);
            },
        }
    }
</script>

<style lang="scss">
    .task-one-time .el-radio.is-bordered.is-checked {
        border-color: #f36f69;
    }
    .task-one-time .el-radio__input.is-checked+.el-radio__label {
        color: #f36f69;
    }
    .task-one-time .el-radio__input.is-checked .el-radio__inner {
        border-color: #f36f69;
        background: #f36f69;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/TaskOneTimeSwitcher.vue